
$(document).ready(function () {


    actOnclickedString($("#id_gateway_0").val())	
	
  $("#id_gateway_0").click(function(){
    actOnclickedString($("#id_gateway_0").val())				
  });
  $("#id_gateway_1").click(function(){
    actOnclickedString($("#id_gateway_1").val())		
  });  
  $("#id_gateway_2").click(function(){
    actOnclickedString($("#id_gateway_2").val())				
  });  
  $("#id_gateway_3").click(function(){	
    actOnclickedString($("#id_gateway_3").val())				
  });
  $("#id_gateway_4").click(function(){
    actOnclickedString($("#id_gateway_4").val())			
  });
  $("#id_gateway_5").click(function(){
    actOnclickedString($("#id_gateway_5").val())			
  }); 
  $("#id_gateway_6").click(function(){
    actOnclickedString($("#id_gateway_6").val())			
  });  
  $("#id_gateway_7").click(function(){
    actOnclickedString($("#id_gateway_7").val())			
  });
  $("#id_gateway_8").click(function(){
    actOnclickedString($("#id_gateway_8").val())			
  });
  $("#id_gateway_9").click(function(){
    actOnclickedString($("#id_gateway_9").val())			
  });  
  $("#id_gateway_10").click(function(){
    actOnclickedString($("#id_gateway_10").val())			
  });   

function actOnclickedString(recString) {
	if(recString  == "dummy")
	{
        console.log("dummy clicked")			
		$("#gatewayNamedummy").show();	
		$("#gatewayNamebankTransfer").hide();			
		$("#gatewayNamephoneApp").hide();			
		$("#gatewayNamepaytm").hide();	
		$("#gatewayNamebraintree").hide();	
		$("#gatewayNamerazorpay").hide();	
		$("#gatewayNamestripe").hide();	
		$("#gatewayNamepayu").hide();	
		$("#gatewayNamepaytmupi").hide();			
		$("#gatewayNamephoneUpiApp").hide();	
		$("#gatewayNamepaytmNetBanking").hide();	
		$("#gatewayNamepaytmWallet").hide();				
		$("#gatewayNamepaytmPostpaid").hide();		
		$("#gatewayNamepaytmDebitCard").hide();				
		$("#gatewayNamepaytmCreditCard").hide();				
	}else if(recString == "bankTransfer")
	{
        console.log("paytm clicked")			
		$("#gatewayNamedummy").hide();	
		$("#gatewayNamebankTransfer").show();		
		$("#gatewayNamephoneApp").hide();		
		$("#gatewayNamepaytm").hide();	
		$("#gatewayNamebraintree").hide();	
		$("#gatewayNamerazorpay").hide();	
		$("#gatewayNamestripe").hide();	
		$("#gatewayNamepayu").hide();	
		$("#gatewayNamepaytmupi").hide();			
		$("#gatewayNamephoneUpiApp").hide();	
		$("#gatewayNamepaytmNetBanking").hide();
		$("#gatewayNamepaytmWallet").hide();				
		$("#gatewayNamepaytmPostpaid").hide();		
		$("#gatewayNamepaytmDebitCard").hide();				
		$("#gatewayNamepaytmCreditCard").hide();		
	}else if(recString == "phoneApp")
	{
        console.log("paytm clicked")			
		$("#gatewayNamedummy").hide();	
		$("#gatewayNamebankTransfer").hide();			
		$("#gatewayNamephoneApp").show();		
		$("#gatewayNamepaytm").hide();	
		$("#gatewayNamebraintree").hide();	
		$("#gatewayNamerazorpay").hide();	
		$("#gatewayNamestripe").hide();	
		$("#gatewayNamepayu").hide();	
		$("#gatewayNamepaytmupi").hide();			
		$("#gatewayNamephoneUpiApp").hide();	
		$("#gatewayNamepaytmNetBanking").hide();
		$("#gatewayNamepaytmWallet").hide();				
		$("#gatewayNamepaytmPostpaid").hide();		
		$("#gatewayNamepaytmDebitCard").hide();				
		$("#gatewayNamepaytmCreditCard").hide();		
	}else if(recString == "paytm")
	{
        console.log("paytm clicked")			
		$("#gatewayNamedummy").hide();	
		$("#gatewayNamebankTransfer").hide();			
		$("#gatewayNamephoneApp").hide();			
		$("#gatewayNamepaytm").show();	
		$("#gatewayNamebraintree").hide();	
		$("#gatewayNamerazorpay").hide();	
		$("#gatewayNamestripe").hide();	
		$("#gatewayNamepayu").hide();	
		$("#gatewayNamepaytmupi").hide();			
		$("#gatewayNamephoneUpiApp").hide();	
		$("#gatewayNamepaytmNetBanking").hide();
		$("#gatewayNamepaytmWallet").hide();				
		$("#gatewayNamepaytmPostpaid").hide();		
		$("#gatewayNamepaytmDebitCard").hide();				
		$("#gatewayNamepaytmCreditCard").hide();		
	}else if(recString == "braintree")
	{
        console.log("braintree clicked")		
		$("#gatewayNamedummy").hide();	
		$("#gatewayNamebankTransfer").hide();			
		$("#gatewayNamephoneApp").hide();			
		$("#gatewayNamepaytm").hide();	
		$("#gatewayNamebraintree").show();	
		$("#gatewayNamerazorpay").hide();	
		$("#gatewayNamestripe").hide();	
		$("#gatewayNamepayu").hide();
		$("#gatewayNamepaytmupi").hide();			
		$("#gatewayNamephoneUpiApp").hide();
		$("#gatewayNamepaytmNetBanking").hide();
		$("#gatewayNamepaytmWallet").hide();				
		$("#gatewayNamepaytmPostpaid").hide();		
		$("#gatewayNamepaytmDebitCard").hide();				
		$("#gatewayNamepaytmCreditCard").hide();		
	}else if(recString == "razorpay")
	{
        console.log("razorpay clicked")		
		$("#gatewayNamedummy").hide();	
		$("#gatewayNamebankTransfer").hide();			
		$("#gatewayNamephoneApp").hide();			
		$("#gatewayNamepaytm").hide();	
		$("#gatewayNamebraintree").hide();	
		$("#gatewayNamerazorpay").show();	
		$("#gatewayNamestripe").hide();	
		$("#gatewayNamepayu").hide();	
		$("#gatewayNamepaytmupi").hide();			
		$("#gatewayNamephoneUpiApp").hide();	
		$("#gatewayNamepaytmNetBanking").hide();
		$("#gatewayNamepaytmWallet").hide();				
		$("#gatewayNamepaytmPostpaid").hide();		
		$("#gatewayNamepaytmDebitCard").hide();				
		$("#gatewayNamepaytmCreditCard").hide();		
	}else if(recString == "stripe")
	{
        console.log("stripe clicked")		
		$("#gatewayNamedummy").hide();
		$("#gatewayNamebankTransfer").hide();			
		$("#gatewayNamephoneApp").hide();			
		$("#gatewayNamepaytm").hide();	
		$("#gatewayNamebraintree").hide();	
		$("#gatewayNamerazorpay").hide();	
		$("#gatewayNamestripe").show();	
		$("#gatewayNamepayu").hide();	
		$("#gatewayNamepaytmupi").hide();			
		$("#gatewayNamephoneUpiApp").hide();	
		$("#gatewayNamepaytmNetBanking").hide();
		$("#gatewayNamepaytmWallet").hide();				
		$("#gatewayNamepaytmPostpaid").hide();		
		$("#gatewayNamepaytmDebitCard").hide();				
		$("#gatewayNamepaytmCreditCard").hide();		
	}else if(recString == "payu")
	{
		console.log("payu clicked");
		$("#gatewayNamedummy").hide();
		$("#gatewayNamebankTransfer").hide();			
		$("#gatewayNamephoneApp").hide();			
		$("#gatewayNamepaytm").hide();	
		$("#gatewayNamebraintree").hide();	
		$("#gatewayNamerazorpay").hide();	
		$("#gatewayNamestripe").hide();	
		$("#gatewayNamepayu").show();	
		$("#gatewayNamepaytmupi").hide();			
		$("#gatewayNamephoneUpiApp").hide();
		$("#gatewayNamepaytmNetBanking").hide();
		$("#gatewayNamepaytmWallet").hide();				
		$("#gatewayNamepaytmPostpaid").hide();		
		$("#gatewayNamepaytmDebitCard").hide();				
		$("#gatewayNamepaytmCreditCard").hide();		
	}else if(recString == "paytmupi")
	{
		console.log("paytmupi clicked");
		$("#gatewayNamedummy").hide();
		$("#gatewayNamebankTransfer").hide();			
		$("#gatewayNamephoneApp").hide();			
		$("#gatewayNamepaytm").hide();	
		$("#gatewayNamebraintree").hide();	
		$("#gatewayNamerazorpay").hide();	
		$("#gatewayNamestripe").hide();	
		$("#gatewayNamepayu").hide();
		$("#gatewayNamepaytmupi").show();			
		$("#gatewayNamephoneUpiApp").hide();	
		$("#gatewayNamepaytmNetBanking").hide();
		$("#gatewayNamepaytmWallet").hide();				
		$("#gatewayNamepaytmPostpaid").hide();		
		$("#gatewayNamepaytmDebitCard").hide();				
		$("#gatewayNamepaytmCreditCard").hide();		
	}else if(recString == "phoneUpiApp")
	{
		console.log("order phoneUpiApp clicked");
		$("#gatewayNamedummy").hide();
		$("#gatewayNamebankTransfer").hide();			
		$("#gatewayNamephoneApp").hide();			
		$("#gatewayNamepaytm").hide();	
		$("#gatewayNamebraintree").hide();	
		$("#gatewayNamerazorpay").hide();	
		$("#gatewayNamestripe").hide();	
		$("#gatewayNamepayu").hide();	
		$("#gatewayNamepaytmupi").hide();			
		$("#gatewayNamephoneUpiApp").show();	
		$("#gatewayNamepaytmNetBanking").hide();
		$("#gatewayNamepaytmWallet").hide();				
		$("#gatewayNamepaytmPostpaid").hide();		
		$("#gatewayNamepaytmDebitCard").hide();				
		$("#gatewayNamepaytmCreditCard").hide();		
	}else if(recString == "paytmNetBanking")
	{
		console.log("paytmNetBanking clicked");
		$("#gatewayNamedummy").hide();
		$("#gatewayNamebankTransfer").hide();			
		$("#gatewayNamephoneApp").hide();			
		$("#gatewayNamepaytm").hide();	
		$("#gatewayNamebraintree").hide();	
		$("#gatewayNamerazorpay").hide();	
		$("#gatewayNamestripe").hide();	
		$("#gatewayNamepayu").hide();	
		$("#gatewayNamepaytmupi").hide();			
		$("#gatewayNamephoneUpiApp").hide();	
		$("#gatewayNamepaytmNetBanking").show();	
		$("#gatewayNamepaytmWallet").hide();				
		$("#gatewayNamepaytmPostpaid").hide();		
		$("#gatewayNamepaytmDebitCard").hide();				
		$("#gatewayNamepaytmCreditCard").hide();		
	}else if(recString == "paytmWallet")
	{
		console.log("paytmWallet clicked");
		$("#gatewayNamedummy").hide();
		$("#gatewayNamebankTransfer").hide();			
		$("#gatewayNamephoneApp").hide();			
		$("#gatewayNamepaytm").hide();	
		$("#gatewayNamebraintree").hide();	
		$("#gatewayNamerazorpay").hide();	
		$("#gatewayNamestripe").hide();	
		$("#gatewayNamepayu").hide();	
		$("#gatewayNamepaytmupi").hide();			
		$("#gatewayNamephoneUpiApp").hide();	
		$("#gatewayNamepaytmNetBanking").hide();
		$("#gatewayNamepaytmWallet").show();				
		$("#gatewayNamepaytmPostpaid").hide();		
		$("#gatewayNamepaytmDebitCard").hide();				
		$("#gatewayNamepaytmCreditCard").hide();		
	}else if(recString == "paytmPostpaid")
	{
		console.log("paytmPostpaid clicked");
		$("#gatewayNamedummy").hide();
		$("#gatewayNamebankTransfer").hide();			
		$("#gatewayNamephoneApp").hide();			
		$("#gatewayNamepaytm").hide();	
		$("#gatewayNamebraintree").hide();	
		$("#gatewayNamerazorpay").hide();	
		$("#gatewayNamestripe").hide();	
		$("#gatewayNamepayu").hide();	
		$("#gatewayNamepaytmupi").hide();			
		$("#gatewayNamephoneUpiApp").hide();	
		$("#gatewayNamepaytmNetBanking").hide();
		$("#gatewayNamepaytmWallet").hide();				
		$("#gatewayNamepaytmPostpaid").show();	
		$("#gatewayNamepaytmDebitCard").hide();				
		$("#gatewayNamepaytmCreditCard").hide();		
	}else if(recString == "paytmDebitCard")
	{
		console.log("paytmDebitCard clicked");
		$("#gatewayNamedummy").hide();
		$("#gatewayNamebankTransfer").hide();			
		$("#gatewayNamephoneApp").hide();			
		$("#gatewayNamepaytm").hide();	
		$("#gatewayNamebraintree").hide();	
		$("#gatewayNamerazorpay").hide();	
		$("#gatewayNamestripe").hide();	
		$("#gatewayNamepayu").hide();	
		$("#gatewayNamepaytmupi").hide();			
		$("#gatewayNamephoneUpiApp").hide();	
		$("#gatewayNamepaytmNetBanking").hide();
		$("#gatewayNamepaytmWallet").hide();				
		$("#gatewayNamepaytmPostpaid").hide();	
		$("#gatewayNamepaytmDebitCard").show();				
		$("#gatewayNamepaytmCreditCard").hide();		
	}else if(recString == "paytmCreditCard")
	{
		console.log("paytmCreditCard clicked");
		$("#gatewayNamedummy").hide();
		$("#gatewayNamebankTransfer").hide();			
		$("#gatewayNamephoneApp").hide();			
		$("#gatewayNamepaytm").hide();	
		$("#gatewayNamebraintree").hide();	
		$("#gatewayNamerazorpay").hide();	
		$("#gatewayNamestripe").hide();	
		$("#gatewayNamepayu").hide();	
		$("#gatewayNamepaytmupi").hide();			
		$("#gatewayNamephoneUpiApp").hide();	
		$("#gatewayNamepaytmNetBanking").hide();
		$("#gatewayNamepaytmWallet").hide();				
		$("#gatewayNamepaytmPostpaid").hide();	
		$("#gatewayNamepaytmDebitCard").hide();				
		$("#gatewayNamepaytmCreditCard").show();		
	}
	
}	
});


